import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(main)/events/EventsPageClient.tsx");
